import { Typography } from '@design-system/typography';
import clsx from 'classnames';
import React, { FC } from 'react';

import { CategoryType } from '~/templates/L2EventPage';

export interface CategoryProps {
  category: CategoryType;
}

const Category: FC<CategoryProps> = ({ category }) => (
  <span className={clsx('category')}>
    <Typography tag="span" size="m" content={category.title} variant="body" />
  </span>
);

export default Category;
